/** Human-friendly label for an IANA timezone (e.g. America/Chicago (Central Standard Time)). */
export function formatTimezoneLabel(iana: string | null | undefined): string {
  const raw = iana?.trim()
  if (!raw) return 'Workspace default'
  try {
    const fmt = new Intl.DateTimeFormat(undefined, { timeZone: raw, timeZoneName: 'long' })
    const name = fmt.formatToParts(new Date()).find((p) => p.type === 'timeZoneName')?.value
    return name ? `${raw} (${name})` : raw
  } catch {
    return raw
  }
}
